import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CurrentUserState } from '../state/current-user.state';

/**
 * Permission guard that checks if user has access to a route based on section/subsection permissions
 *
 * Usage in routes:
 * {
 *   path: 'users',
 *   component: UserListComponent,
 *   canActivate: [authGuard, permissionGuard],
 *   data: { section: 'Administration', subsection: 'Users' }
 * }
 */
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const currentUserState = inject(CurrentUserState);
  const router = inject(Router);

  // Get required permissions from route data
  const section = route.data['section'];
  const subsection = route.data['subsection'];

  // If no permission metadata, allow access (public route)
  if (!section || !subsection) {
    return true;
  }

  // Check if user has access
  const hasAccess = currentUserState.hasAccess(section, subsection);

  if (hasAccess) {
    return true;
  }

  // No permission - redirect to forbidden page
  console.warn(`Access denied to ${section}/${subsection}`);
  router.navigate(['/forbidden']);
  return false;
};
